export const ON_CHANGE_NODE = 1;
export const ON_TREE_ADD = 2;
export const ON_TREE_DELETE = 3;
export const ON_LOAD = "posts/fetchPosts/fulfilled";
export const RELOAD = "RELOAD";